webpackJsonp([1],{

/***/ "+xQ/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Kd0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1UnP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HHL4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bade07e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("1UnP")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ['logoURL', 'title', 'page', 'companyName', 'width'],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['zoomEnabled', 'contentsEnabled', 'searchEnabled', 'languagesEnabled', 'downloadEnabled', 'printEnabled', 'rightToLeft', 'companyLogo', 'downloadPath', 'showContents', 'showLanguages', 'showSearch', 'isZoomed']), {
    divider: function divider() {
      if (this.rightToLeft) return 'chevron-left';
      return 'chevron-right';
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleLanguages: 'TOGGLE_LANGUAGES',
    toggleZoom: 'TOGGLE_ZOOM',
    toggleSearch: 'TOGGLE_SEARCH'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-008965a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(_vm.zoomEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()])])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("V56Z")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0d4e3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("yHNM")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b29920c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1})}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1})}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1})}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1})}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("+xQ/")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf482d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("Pb/U")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 1) {
        return this.basePath + '/static/_thumbs/' + index + '.png';
      } else {
        return this.basePath + '/static/_thumbs/' + index + '-' + sectionIndex + '.png';
      }
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
      console.log(this.searchResults);
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-685becc3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.pageIndex, searchResult.sectionIndex),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("Nwp4")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    isVimeo: function isVimeo() {
      return this.videoURL.search('vimeo') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab3c999","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]):_vm._e(),_vm._v(" "),(_vm.isVimeo)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","src":_vm.videoURL,"width":"640","height":"360","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)])])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Nl3u")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "basePath", "galleryIndex"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eded527","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1),_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("0Kd0")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4eded527"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    MobileContainer: components_mobile_MobileContainer,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    VideoContainer: src_components_VideoContainer,
    GalleryContainer: src_components_GalleryContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages'])),
  mounted: function mounted() {
    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42011bf9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[(_vm.isMobile && _vm.mobileSwitch)?[_c('mobile-container')]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("HHL4")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';

var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Terre des Hommes - Annual Report 2017",
  "shortTitle": "",
  "description": "",
  "width": 1365,
  "height": 1024,
  "currentLanguage": "EN",
  "languages": [],
  "basePath": "/making-children-heard",
  // "basePath": "",
  "companyLogo": "1-logo.png",
  "publishURL": "https://s3-eu-west-1.amazonaws.com/touchline/terre-des-hommes/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": false,
    "mobileSwitch": false
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "  \n        <img id=\"1-title\" class=\"halfScale\" src=\"/making-children-heard/static/_content/1-title.png\" style=\"top: 480px; left: 220px;\"/>\n        <img id=\"1-sub\" class=\"halfScale\" src=\"/making-children-heard/static/_content/1-sub.png\" style=\"top: 830px; left: 487px;\"/>\n        <img id=\"1-arrow\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/1-arrow.png\" onclick=\"Publish.nextPage()\" style=\"top: 866px; left: 1252px;\"/>\n        <img id=\"1-logo\" class=\"halfScale\" src=\"/making-children-heard/static/_content/1-logo.png\" style=\"top: 71px; left: 835px;\"/>\n        ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(idOf(\"1-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)\n          .fromTo(idOf(\"1-sub\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n          .fromTo(idOf(\"1-logo\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, \"-=0.4\")\n          .fromTo(idOf(\"1-arrow\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0, onComplete: function() {\n            pg1Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});\n            pg1Bounce.to(idOf(\"1-arrow\"), 0.6, {x:-20, delay:0.8})\n            .to(idOf(\"1-arrow\"), 1, {x:0, ease:Bounce.easeOut}, \"-=0\")\n          }}, \"-=0.4\")\n        }\n        \n\n        function onPageLeave() {\n          pg1Anim.stop();\n          pg1Bounce.stop();\n        }\n      ",
    "searchText": "MAKING CHILDREN HEARD ACROSS THE GLOBE  ANNUAL REPORT 2017 ©TDH/Matthew O'Brien  Use your arrow keys or mouse, or swipe to navigate through the publication"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img id=\"2-title\" class=\"halfScale\" src=\"/making-children-heard/static/_content/2-title.png\" style=\"top: 340px; left: 667px;\"/>\n      <img id=\"2-cont\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/2-cont.png\" onclick=\"showOverlay('pg2-pop')\" style=\"top: 861px; left: 948px;\"/>\n      <img class=\"halfScale 2-img\" src=\"/making-children-heard/static/_content/2-img.jpg\" style=\"top: 429px; left: 142px;\"/>\n      <img class=\"halfScale 2-img\" src=\"/making-children-heard/static/_content/2-text.png\" style=\"top: 680px; left: 144px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:799px;left:593px;width:188px;height:21px\">\n        <a href=\"http://www.childrenonthemove.org/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:829px;left:363px;width:308px;height:23px\">\n        <a href=\"http://www.childrenonthemove.org/\" target=\"_blank\"></a>\n      </div>\n\n      <div id=\"pg2-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg2-pop.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg2-pop')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n        <div class=\"contentLink\" style=\"top:430px;left:413px;width:224px;height:21px\">\n          <a href=\"https://destination-unknown.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"top:643px;left:583px;width:127px;height:23px\">\n          <a href=\"http://www.time-to-talk.info/en/home/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"top:459px;left:846px;width:132px;height:23px\">\n          <a href=\"https://www.childrenwin.org/\" target=\"_blank\"></a>\n        </div>\n      </div>\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg2Anim = new TimelineMax();\n        pg2Anim.fromTo(idOf(\"2-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)\n        .staggerFromTo(cOf(\"2-img\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, 0.4, \"-=0.4\")\n        .fromTo(idOf(\"2-cont\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"2-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: addContentLinks}, \"-=0.4\")\n      }\n\n      function onPageLeave() {\n        pg2Anim.stop();\n        removeContentLinks();\n        hideOverlay('pg2-pop');\n      }\n      ",
    "searchText": "02/14  TERRE DES HOMMES  FOREWORD  FOREWORD  BACK  ©TDH  Lysiane André is Chair of the Terre des Hommes International Board  Terre des Hommes works to make positive change happen for vulnerable and disadvantaged children by defending their rights and helping them reach their full potential across the globe. In 2017, we took yet more steps towards achieving this. We united with six other organisations who specialise in child rights to end violence against children, and encourage governments worldwide to renew their commitment to respect the rights of every child. As co-chair of the Initiative for Child Rights in the Global Compacts, Terre des Hommes was crucial in organising the Global Conference for Children on the  Move. This conference showed our commitment to putting children at the heart of two UN agreements on how governments can best manage migration and care for refugees.  Click to continue reading  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 3-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 3-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n      \n      <img id=\"3-title\" class=\"halfScale\" src=\"/making-children-heard/static/_content/3-title.png\" style=\"top: 340px; left: 667px;\"/>\n      <img id=\"3-cont\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/3-cont.png\" onclick=\"showOverlay('pg3-pop')\" style=\"top: 861px; left: 948px;\"/>\n      <img class=\"halfScale 3-img\" src=\"/making-children-heard/static/_content/3-img.jpg\" style=\"top: 430px; left: 142px;\"/>\n      <img class=\"halfScale 3-img\" src=\"/making-children-heard/static/_content/3-text.png\" style=\"top: 683px; left: 144px;\"/>\n\n      <div id=\"pg3-pop\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg3-pop.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg3-pop')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg3Anim = new TimelineMax();\n        pg3Anim.fromTo(idOf(\"3-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)\n        .staggerFromTo(cOf(\"3-img\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, 0.4, \"-=0.4\")\n        .fromTo(idOf(\"3-cont\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"3-arrow\"), 0.8, {opacity:0}, {opacity:1}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg3Anim.stop();\n        hideOverlay('pg3-pop');\n      }\n      ",
    "searchText": "03/14  TERRE DES HOMMES  FOREWORD  FOREWORD  BACK  ©TDH  Delphine Moralis is Secretary General of the Terre des Hommes International Federation  Terre des Hommes stands with children and young people to demand and facilitate change. From innovating primary health care for children in rural areas in West Africa, to educational activities in Lebanon for Syrian refugee children. From listening to working children about their fear of verbal, physical and sexual abuse, to working with the industry to achieve supply chains free of exploitative child labour. Our work in 2017 has been true to our mission, to protect children, their rights, and equitable development. But as we move forward at a fast pace towards 2030, many commitments within  the Sustainable Development Goals concerning children are still far from reality. Still today, 357 million children live in zones affected by conflict, 73 million children work in hazardous or dangerous conditions, 10 million children are enslaved, and at least as many children live in forced displacement. This is no time to be complacent.  Click to continue reading  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 4-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 4-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img id=\"4-title\" class=\"halfScale\" src=\"/making-children-heard/static/_content/4-title.png\" style=\"top: 461px; left: 471px;\"/>\n      <img class=\"halfScale 4-img\" src=\"/making-children-heard/static/_content/4-img.jpg\" style=\"top: 100px; left: 425px;\"/>\n\n      <img class=\"halfScaleC 4-ctr\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg4-pop-1')\" style=\"top: 636px; left: 125px;\"/>\n      <img class=\"halfScaleC 4-ctr\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg4-pop-2')\" style=\"top: 792px; left: 125px;\"/>\n\n      <div id=\"pg4-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg4-pop1.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg4-pop-1')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n        <div class=\"contentLink\" style=\"top:612px;left:373px;width:191px;height:23px\">\n          <a href=\"https://accountablenow.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"top:369px;left:848px;width:247px;height:23px\">\n          <a href=\"https://www.keepingchildrensafe.org.uk/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"contentLink\" style=\"top:583px;left:771px;width:428px;height:23px\">\n          <a href=\"mailto:childsafeguarding@terredeshommes.org\" target=\"_blank\"></a>\n        </div>\n      </div>\n\n      <div id=\"pg4-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg4-pop-2.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg4-pop-2')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg4Anim = new TimelineMax();\n        pg4Anim.fromTo(idOf(\"4-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)\n        .staggerFromTo(cOf(\"4-ctr\"), 0.8, {opacity:0}, {opacity:1}, 0.4, \"-=0.4\")\n        .fromTo(cOf(\"4-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          cOf(\"4-ctr\")[0].className += \" pointer pulse animatedpulse\";\n          cOf(\"4-ctr\")[1].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n\n      function onPageLeave() {\n        pg4Anim.stop();\n        cOf(\"4-ctr\")[0].className = \"halfScaleC 4-ctr\";\n        cOf(\"4-ctr\")[1].className = \"halfScaleC 4-ctr\";\n        hideOverlay('pg4-pop-1');\n        hideOverlay('pg4-pop-2');\n      }\n      ",
    "searchText": "04/14  TERRE DES HOMMES  ABOUT  ©TDH / Andrea Frazzetta  ABOUT TERRE DES HOMMES  BACK  Click to read ‘Safeguarding and accountability’  Click to read ‘Who we are’  Founded in 1966, the Terre des Hommes International Federation strives to empower children to shape the future they want to live in, and to guarantee their rights are respected in their entirety. We work to make this vision a reality by supporting children anywhere where decisions are made or actions are taken which affect them. From helping them in the communities they live in to voicing their concerns to the world leaders, governments and international institutions who  can improve their situations, Terre des Hommes places children at the heart of any debate affecting them. Terre des Hommes has helped millions of children since our movement was first founded. We have provided children with healthcare, humanitarian assistance and an improved quality of life. We have protected them from exploitation, violence and abuse. And we have empowered children to become the masters of their own future.  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 5-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 5-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 5-1-title\" src=\"/making-children-heard/static/_content/5-title.png\" style=\"top: 258px; left: 523px;\"/>\n      <img class=\"halfScale 5-1-title\" src=\"/making-children-heard/static/_content/5-sub.png\" style=\"top: 394px; left: 389px;\"/>\n\n      <img id=\"5-img\" class=\"halfScale\" src=\"/making-children-heard/static/_content/5-img-1.jpg\" style=\"top: 601px; left: 364px;\"/>\n      <img id=\"5-read\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/read-more.png\" onclick=\"Publish.nextSection()\" style=\"top: 515px; left: 747px;\"/>\n      ",
    "script": "\n      function onPageEnter() {\n        pg5Anim = new TimelineMax();\n        pg5Anim.staggerFromTo(cOf(\"5-1-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .fromTo(idOf(\"5-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.6\")\n        .fromTo(idOf(\"5-read\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"5-1-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          pg5Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});\n          pg5Bounce.to(idOf(\"5-read\"), 0.6, {y:-20, delay:0.8})\n          .to(idOf(\"5-read\"), 1, {y:0, ease:Bounce.easeOut}, \"-=0\")\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg5Anim.stop();\n        pg5Bounce.stop();\n      }\n      ",
    "searchText": "05/14  TERRE DES HOMMES  CHILDREN IN MIGRATION  PROTECTING CHILDREN ON THE MOVE From fleeing conflict or disaster to seeking a better life or reuniting with their families, children are on the move across the globe. Here are just some of the ways Terre des Hommes is providing them with protection, security and hope BACK  NEXT  READ MORE  ©TDH – Iraq"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 5-2-title\" src=\"/making-children-heard/static/_content/5-iraq.png\" style=\"top: 180px; left: 763px;\"/>\n      <img class=\"halfScale 5-2-title\" src=\"/making-children-heard/static/_content/5-sub2.png\" style=\"top: 232px; left: 383px;\"/>\n      <img class=\"halfScale 5-2-title\" src=\"/making-children-heard/static/_content/5-bangladesh.png\" style=\"top: 548px; left: 711px;\"/>\n      <img id=\"5-img-2\" class=\"halfScale\" src=\"/making-children-heard/static/_content/5-img-2.jpg\" style=\"top: 619px; left: 809px;\"/>\n\n      <img class=\"halfScaleC 5-btn-2\" src=\"/making-children-heard/static/_content/btn-play.png\" onclick=\"Publish.openVideo('https://www.youtube.com/embed/_nYcQ8B4Il4')\" style=\"top: 212px; left: 125px;\"/>\n      <img class=\"halfScaleC 5-btn-2\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg5-pop-1')\" style=\"top: 587px; left: 125px;\"/>\n      <img class=\"halfScaleC 5-btn-2\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg5-pop-2')\" style=\"top: 742px; left: 125px;\"/>\n\n      <img class=\"halfScaleC 5-btn-2\" src=\"/making-children-heard/static/_content/btn-down.jpg\" onclick=\"Publish.nextSection()\" style=\"top: 823px; left: 668px;\"/>\n\n      <div id=\"pg5-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg5-pop1.jpg\">\n        <div class=\"abs pointer\" onclick=\"Publish.openVideo('https://player.vimeo.com/video/241848396?autoplay=1&color=ff9933&title=0&byline=0')\" style=\"top:354px;left:949px;width:95px;height:95px;\"></div>\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg5-pop-1')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n\n      <div id=\"pg5-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg5-pop2.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg5-pop-2')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg5sec2Anim = new TimelineMax();\n        pg5sec2Anim.staggerFromTo(cOf(\"5-2-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.6, 0.8)\n        .fromTo(idOf(\"5-img-2\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.6\")\n        .staggerFromTo(cOf(\"5-btn-2\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          cOf(\"5-btn-2\")[0].className += \" pointer pulse animatedpulse\";\n          cOf(\"5-btn-2\")[1].className += \" pointer pulse animatedpulse\";\n          cOf(\"5-btn-2\")[2].className += \" pointer pulse animatedpulse\";\n          cOf(\"5-btn-2\")[3].className += \" pointer pulse animatedpulse\";\n        }}, 0.4, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg5sec2Anim.stop();\n        cOf(\"5-btn-2\")[0].className = \"halfScaleC 5-btn-2\";\n        cOf(\"5-btn-2\")[1].className = \"halfScaleC 5-btn-2\";\n        cOf(\"5-btn-2\")[2].className = \"halfScaleC 5-btn-2\";\n        cOf(\"5-btn-2\")[3].className = \"halfScaleC 5-btn-2\";\n        hideOverlay('pg5-pop-1');\n        hideOverlay('pg5-pop-2');\n      }\n      ",
    "searchText": "05/14  CHILDREN IN MIGRATION  IRAQ  Click to view Watch Ahmed's story here  “Since he started the treatment, Ahmed improved dramatically… Now he goes to the Child Friendly Space and says who he wants to play with” – Ahmed’s mother In protracted crisis, it is the most vulnerable children who suffer the most. Terre des Hommes (Italy) is working with disabled children in northern Iraq by promoting community-based rehabilitation, raising awareness about disability within  communities and training teachers how to teach children with special needs. The programme helped 250 children with disabilities in 2017, and also provided psychological support to them and their families.  BANGLADESH  Click to read how TDH is helping refugees in Greece  Click to read how we are providing healthcare in Myanmar  In 2017, over 600,000 Rohingya refugees were forced to escape a renewed wave of violence in Rakhine, Myanmar. In Bangladesh, Terre des Hommes (Lausanne) provided four-year-old Maya (pictured right) and over 2,000 other refugees with treatment for malnutrition. 900 children also received psychological and social support.  ©TDH"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 5-3-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 5-3-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 5-3-title\" src=\"/making-children-heard/static/_content/5-lebanon.png\" style=\"top: 183px; left: 736px;\"/>\n      <img class=\"halfScale 5-3-title\" src=\"/making-children-heard/static/_content/5-sub3.png\" style=\"top: 231px; left: 421px;\"/>\n\n      <img id=\"5-img-3\" class=\"halfScale\" src=\"/making-children-heard/static/_content/5-img-3.jpg\" style=\"top: 449px; left: 364px;\"/>\n\n      <img class=\"halfScaleC 5-btn-3\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg5-pop-3')\" style=\"top: 583px; left: 125px;\"/>\n      <img class=\"halfScaleC 5-btn-3\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg5-pop-4')\" style=\"top: 767px; left: 125px;\"/>\n\n      <div id=\"pg5-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg5-pop3.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg5-pop-3')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n\n      <div id=\"pg5-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg5-pop4.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg5-pop-4')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg5sec3Anim = new TimelineMax();\n        pg5sec3Anim.staggerFromTo(cOf(\"5-3-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .fromTo(idOf(\"5-img-3\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.6\")\n        .staggerFromTo(cOf(\"5-btn-3\"), 0.8, {opacity:0}, {opacity:1}, 0.4, \"-=0.4\") \n        .fromTo(cOf(\"5-3-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          cOf(\"5-btn-3\")[0].className += \" pointer pulse animatedpulse\";\n          cOf(\"5-btn-3\")[1].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg5sec3Anim.stop();\n        cOf(\"5-btn-3\")[0].className = \"halfScaleC 5-btn-3\";\n        cOf(\"5-btn-3\")[1].className = \"halfScaleC 5-btn-3\";\n        hideOverlay('pg5-pop-3');\n        hideOverlay('pg5-pop-4');\n\n      }\n      ",
    "searchText": "05/14  CHILDREN IN MIGRATION  LEBANON “I feel so relieved now that we have left Syria and the war behind” – Sayid, 10 Over 7,000 refugee children from Syria enrolled in educational activities in Lebanon in 2017 thanks to the Back to the Future programme – run by Terre des Hommes (Italy) and Terre des Hommes (Netherlands).  The programme helps children like ten-year-old Sayid, who is now learning basic literacy and numeracy skills after escaping the war which killed his sister in an airstrike. © Andy Hall  BACK  NEXT  Click to read about our Kenya project  Click to read about our West Africa project"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 6-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 6-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 6-1-title\" src=\"/making-children-heard/static/_content/6-title.png\" style=\"top: 234px; left: 521px;\"/>\n      <img class=\"halfScale 6-1-title\" src=\"/making-children-heard/static/_content/6-sub.png\" style=\"top: 372px; left: 380px;\"/>\n\n      <img id=\"6-img-1\" class=\"halfScale\" src=\"/making-children-heard/static/_content/6-img-1.jpg\" style=\"top: 579px; left: 365px;\"/>\n\n      <img id=\"6-read\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/read-more.png\" onclick=\"Publish.nextSection()\" style=\"top: 492px; left: 748px;\"/>\n      ",
    "script": "\n      function onPageEnter() {\n        pg6Anim = new TimelineMax();\n        pg6Anim.staggerFromTo(cOf(\"6-1-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .fromTo(idOf(\"6-img-1\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.6\")\n        .fromTo(idOf(\"6-read\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"6-1-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          pg6Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});\n          pg6Bounce.to(idOf(\"6-read\"), 0.6, {y:-20, delay:0.8})\n          .to(idOf(\"6-read\"), 1, {y:0, ease:Bounce.easeOut}, \"-=0\")\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg6Anim.stop();\n        pg6Bounce.stop();\n      }\n      ",
    "searchText": "06/14  TERRE DES HOMMES  CHILD LABOUR  IMPROVING THE LIVES OF WORKING CHILDREN 152 million children across the globe are trapped in exploitative child labour, with 73 million working in hazardous conditions. Terre des Hommes works with the children affected, their families and communities to give them a childhood again BACK  READ MORE  NEXT  ©TDH"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 6-2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 6-2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 6-2-title\" src=\"/making-children-heard/static/_content/6-global.png\" style=\"top: 183px; left: 746px;\"/>\n      <img class=\"halfScale 6-2-title\" src=\"/making-children-heard/static/_content/6-sub2.png\" style=\"top: 231px; left: 460px;\"/>\n\n      <img class=\"halfScaleC 6-btn-2\" src=\"/making-children-heard/static/_content/btn-play.png\" onclick=\"Publish.openVideo('https://www.youtube.com/embed/xHwzBOtTadw')\" style=\"top: 509px; left: 125px;\"/>\n      <img class=\"halfScaleC 6-btn-2\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg6-pop-1')\" style=\"top: 737px; left: 125px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:460px;left:701px;width:79px;height:21px\">\n        <a href=\"https://www.terredeshommes.org/child-labourers-flag-abuse-and-sexual-violence-as-biggest-fears-in-ground-breaking-tdh-survey/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:491px;left:362px;width:49px;height:21px\">\n        <a href=\"https://www.terredeshommes.org/child-labourers-flag-abuse-and-sexual-violence-as-biggest-fears-in-ground-breaking-tdh-survey/\" target=\"_blank\"></a>\n      </div>\n\n      <div class=\"addContentLink\" style=\"top:369px;left:1084px;width:141px;height:21px\">\n        <a href=\"http://childlabour2017.org/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:400px;left:807px;width:419px;height:21px\">\n        <a href=\"http://childlabour2017.org/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:430px;left:807px;width:155px;height:21px\">\n        <a href=\"http://childlabour2017.org/\" target=\"_blank\"></a>\n      </div>\n\n      <div id=\"pg6-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg6-pop1.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg6-pop-1')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n        <div class=\"contentLink\" style=\"top:400px;left:374px;width:292px;height:23px\">\n          <a href=\"http://www.responsible-mica-initiative.com/\" target=\"_blank\"></a>\n        </div>\n      </div>\n      \n      ",
    "script": "\n      function onPageEnter() {\n        pg6sec2Anim = new TimelineMax();\n        pg6sec2Anim.staggerFromTo(cOf(\"6-2-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .staggerFromTo(cOf(\"6-btn-2\"), 0.8, {opacity:0}, {opacity:1}, 0.4, \"-=0.4\")\n        .fromTo(cOf(\"6-2-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          addContentLinks();\n          cOf(\"6-btn-2\")[0].className += \" pointer pulse animatedpulse\";\n          cOf(\"6-btn-2\")[1].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n\n      function onPageLeave() {\n        pg6sec2Anim.stop();\n        removeContentLinks();\n        cOf(\"6-btn-2\")[0].className = \"halfScaleC 6-btn-2\";\n        cOf(\"6-btn-2\")[1].className = \"halfScaleC 6-btn-2\";\n        hideOverlay('pg6-pop-1');\n      }\n      ",
    "searchText": "06/14  CHILD LABOUR  GLOBAL “I’m proud to help my family, but the work is tiring – especially lifting the heavy oven plate. I have burned myself many times” – Ana, 10  BACK  Click to view What do working children think about their jobs?  Click to read how TDH is helping children working in mica mines  The most important voices when discussing child labour are children themselves. Terre des Hommes (Germany), together with Save the Children, Kindernothilfe and other child rights groups, undertook the Time to Talk survey in 2017. The survey interviewed around 1,800 working children in 36 countries across the globe about their experiences, and will use their testimony to find lasting solutions to the problem of exploitative child labour.  Terre des Hommes launched the results of the Time to Talk survey at the Fourth Global Conference on the Sustained Eradication of Child Labour in Buenos Aires, Argentina. The survey received international media coverage and was also presented directly to officials at the event. The report highlighted how children’s biggest work-related fears are physical, verbal and sexual abuse. However, they appreciated being able to support their families and earn enough money to afford an education.  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 7-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 7-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 7-1-title\" src=\"/making-children-heard/static/_content/7-title.png\" style=\"top: 591px; left: 526px;\"/>\n      <img class=\"halfScale 7-1-title\" src=\"/making-children-heard/static/_content/7-sub.png\" style=\"top: 739px; left: 368px;\"/>\n\n      <img id=\"7-img-1\" class=\"halfScale\" src=\"/making-children-heard/static/_content/7-img-1.jpg\" style=\"top: 124px; left: 366px;\"/>\n      <img id=\"7-read\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/read-more.png\" onclick=\"Publish.nextSection()\" style=\"top: 860px; left:748px;\"/>\n      ",
    "script": "\n      function onPageEnter() {\n        pg7Anim = new TimelineMax();\n        pg7Anim.staggerFromTo(cOf(\"7-1-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.6, 0.8)\n        .fromTo(idOf(\"7-img-1\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(idOf(\"7-read\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"7-1-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          pg7Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});\n          pg7Bounce.to(idOf(\"7-read\"), 0.7, {y:-20, delay:0.8})\n          .to(idOf(\"7-read\"), 1, {y:0, ease:Bounce.easeOut}, \"-=0\")\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg7Anim.stop();\n        pg7Bounce.stop();\n      }\n      ",
    "searchText": "07/14  TERRE DES HOMMES  CHILD SEXUAL EXPLOITATION  ©TDH  BACK  STOPPING CHILD SEXUAL EXPLOITATION Over one million children are trapped in the sex industry worldwide, with many girls being a virgin when they receive their first customer, and children infected with HIV within months. Terre des Hommes is committed to fighting for a brighter, better future for them READ MORE  NEXT"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 7-2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 7-2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 7-2-title\" src=\"/making-children-heard/static/_content/7-netherlands.png\" style=\"top: 245px; left: 704px;\"/>\n      <img class=\"halfScale 7-2-title\" src=\"/making-children-heard/static/_content/7-sub2.png\" style=\"top: 285px; left: 393px;\"/>\n\n      <img class=\"halfScale 7-2-img\" src=\"/making-children-heard/static/_content/7-img-2.jpg\" style=\"top: 374px; left: 809px;\"/>\n      <img class=\"halfScaleC 7-2-btn\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg7-pop-1')\" style=\"top: 521px; left:125px;\"/>\n      \n      <div class=\"addContentLink\" style=\"top:369px;left:364px;width:196px;height:21px\">\n        <a href=\"https://watchnederland.nl/\" target=\"_blank\"></a>\n      </div>\n\n      <div id=\"pg7-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg7-pop1.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg7-pop-1')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n        <div class=\"contentLink\" style=\"top:705px;left:496px;width:95px;height:23px\">\n          <a href=\"https://www.netflix.com/be-en/title/80182553\" target=\"_blank\"></a>\n        </div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg7sec2Anim = new TimelineMax();\n        pg7sec2Anim.staggerFromTo(cOf(\"7-2-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .fromTo(cOf(\"7-2-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"7-2-btn\"), 0.8, {opacity:0}, {opacity:1}, \"-=0.4\")\n        .fromTo(cOf(\"7-2-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          addContentLinks();\n          cOf(\"7-2-btn\")[0].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg7sec2Anim.stop();\n        removeContentLinks();\n        cOf(\"7-2-btn\")[0].className = \"halfScaleC 7-2-btn\";\n        hideOverlay('pg7-pop-1');\n      }\n      ",
    "searchText": "07/14 TERRE DES HOMMES  CHILD SEXUAL EXPLOITATION  NETHERLANDS “When I was abused by pimps, I sometimes begged customers for help. But the customers always get away with it – and they always pay the pimps” – Anonymous  BACK  Click to read how TDH is tackling online child sexual exploitation  WATCH Nederland, a hotline set up by Terre des Hommes (Netherlands) and other organisations in 2017, allows members of the public to report suspicions of child trafficking and sexual exploitation. The hotline has received 131 reports, 53 of which were assessed as being substantial enough to hand over to the Dutch police, with WATCH also using fake online profiles as bait to catch and monitor traffickers, pimps and their customers.  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 8-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 8-1-title\" src=\"/making-children-heard/static/_content/8-title.png\" style=\"top: 264px; left: 443px;\"/>\n      <img class=\"halfScale 8-1-title\" src=\"/making-children-heard/static/_content/8-sub.png\" style=\"top: 401px; left: 367px;\"/>\n\n      <img class=\"halfScale 8-1-img\" src=\"/making-children-heard/static/_content/8-img-1.jpg\" style=\"top: 618px; left: 366px;\"/>\n      <img id=\"8-read\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/read-more.png\" onclick=\"Publish.nextSection()\" style=\"top: 529px; left:747px;\"/>\n      ",
    "script": "\n      function onPageEnter() {\n        pg8Anim = new TimelineMax();\n        pg8Anim.staggerFromTo(cOf(\"8-1-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.6, 0.8)\n        .fromTo(cOf(\"8-1-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(idOf(\"8-read\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"8-1-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          pg8Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});\n          pg8Bounce.to(idOf(\"8-read\"), 0.8, {y:-20, delay:0.8})\n          .to(idOf(\"8-read\"), 1, {y:0, ease:Bounce.easeOut}, \"-=0\")\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg8Anim.stop();\n        pg8Bounce.stop();\n      }\n      ",
    "searchText": "08/14  TERRE DES HOMMES  SUSTAINABLE DEVELOPMENT  ACHIEVING THE SUSTAINABLE DEVELOPMENT GOALS Children and youth are the main participants in their own development and must play a crucial role in achieving the Sustainable Development Goals (SDGs). Terre des Hommes is working to put their needs at the heart of the implementation of the SDGs BACK  NEXT READ MORE  ©Mundubat/TDH France  READ MORE"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-2-title\" src=\"/making-children-heard/static/_content/8-columbia.png\" style=\"top: 245px; left: 731px;\"/>\n      <img class=\"halfScale 8-2-title\" src=\"/making-children-heard/static/_content/8-sub2.png\" style=\"top: 290px; left: 438px;\"/>\n\n      <img class=\"halfScale 8-2-img\" src=\"/making-children-heard/static/_content/8-img-2.jpg\" style=\"top: 432px; left: 809px;\"/>\n      <img class=\"halfScaleC 8-2-btn\" src=\"/making-children-heard/static/_content/btn-down.jpg\" onclick=\"Publish.nextSection()\" style=\"top: 792px; left: 726px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:290px;left:612px;width:145px;height:21px\">\n        <a href=\"http://tallerabierto.org/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg8sec2Anim = new TimelineMax();\n        pg8sec2Anim.staggerFromTo(cOf(\"8-2-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .fromTo(cOf(\"8-2-img\"), 0.8, {opacity:0, x:30}, {opacity:1, x:0}, \"-=0.4\")\n        .fromTo(cOf(\"8-2-btn\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          addContentLinks();\n          cOf(\"8-2-btn\")[0].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg8sec2Anim.stop();\n        removeContentLinks();\n        cOf(\"8-2-btn\")[0].className = \"halfScaleC 8-2-btn\";\n      }\n      ",
    "searchText": "08/14  SUSTAINABLE DEVELOPMENT  COLOMBIA “Thanks to Taller Abierto and Terre des Hommes, we get to learn about how armed groups recognise and recruit vulnerable children, and have established our own strategy to ensure no other children are recruited” – Anonymous teenager in Buenaventura Despite the historic peace deal agreed between the Colombian government and Farc rebels, children and young people are still having their rights violated on a daily basis in the city of Buenaventura. A joint report by Terre des Hommes (France) and Terre des Hommes (Switzerland) shone a light on how children are blocked from attending school by armed groups, who charge a tax to travel in between districts. The report also highlighted how girls face a higher risk of sexual abuse if they live in territories controlled by these groups."
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8-3.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-3-title\" src=\"/making-children-heard/static/_content/8-sudan.png\" style=\"top: 245px; left: 708px;\"/>\n      <img class=\"halfScale 8-3-title\" src=\"/making-children-heard/static/_content/8-sub3.png\" style=\"top: 289px; left: 373px;\"/>\n\n      <img class=\"halfScale 8-3-img\" src=\"/making-children-heard/static/_content/8-img-2.jpg\" style=\"top: 540px; left: 144px;\"/>\n      <img class=\"halfScale 8-3-img\" src=\"/making-children-heard/static/_content/8-img-3.jpg\" style=\"top: 539px; left: 368px;\"/>\n      <img class=\"halfScaleC 8-3-btn\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg8-pop-1')\" style=\"top: 741px; left:125px;\"/>\n\n      <img class=\"halfScaleC 8-3-btn\" src=\"/making-children-heard/static/_content/btn-down.jpg\" onclick=\"Publish.nextSection()\" style=\"top: 485px; left: 939px;\"/>\n\n      <div id=\"pg8-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg8-pop1.jpg\">\n        <div class=\"abs pointer\" onclick=\"Publish.openVideo('https://player.vimeo.com/video/256753961?autoplay=1&title=0&byline=0&portrait=0')\" style=\"top:408px;left:989px;width:95px;height:95px;\"></div>\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg8-pop-1')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg8sec3Anim = new TimelineMax();\n        pg8sec3Anim.staggerFromTo(cOf(\"8-3-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .staggerFromTo(cOf(\"8-3-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, 0.4, \"-=0.4\")\n        .fromTo(cOf(\"8-3-btn\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          cOf(\"8-3-btn\")[0].className += \" pointer pulse animatedpulse\";\n          cOf(\"8-3-btn\")[1].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg8sec3Anim.stop();\n        cOf(\"8-3-btn\")[0].className = \"halfScaleC 8-3-btn\";\n        cOf(\"8-3-btn\")[1].className = \"halfScaleC 8-3-btn\";\n        hideOverlay('pg8-pop-1')\n      }\n      ",
    "searchText": "08/14  TERRE DES HOMMES  SUSTAINABLE DEVELOPMENT  SOUTH SUDAN “At night, we don't turn on the lights to study. You cannot attract attention” – Roger, 16 Sophia lives under siege with her children Anna and Roger in Yei, South Sudan. Terre des Hommes (Lausanne)’s urban farming project has provided seeds and tools to over 2,000 vulnerable families in Yei, allowing them to fight malnutrition by growing and  storing crops to eat and sell. Government security forces cut off the city from the surrounding area in 2016, making the tomatoes, aubergines, okra, cabbage and onions citizens can grow in Yei essential to their survival. ©TDH / Ollivier Girard  Click to read how our Indifesa campaign champions gender equality"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8-4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 8-4-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 8-4-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 8-4-title\" src=\"/making-children-heard/static/_content/8-kenya.png\" style=\"top: 245px; left: 753px;\"/>\n      <img class=\"halfScale 8-4-title\" src=\"/making-children-heard/static/_content/8-sub4.png\" style=\"top: 289px; left: 432px;\"/>\n\n      <img class=\"halfScale 8-4-img\" src=\"/making-children-heard/static/_content/8-img-4.jpg\" style=\"top: 584px; left: 144px;\"/>\n      <img class=\"halfScale 8-4-img\" src=\"/making-children-heard/static/_content/8-img-5.jpg\" style=\"top: 584px; left: 365px;\"/>\n      <img class=\"halfScaleC 8-4-btn\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg8-pop-2')\" style=\"top: 226px; left:125px;\"/>\n      <img class=\"halfScaleC 8-4-btn\" src=\"/making-children-heard/static/_content/btn-plus.jpg\" onclick=\"showOverlay('pg8-pop-3')\" style=\"top: 399px; left: 125px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:460px;left:447px;width:141px;height:21px\">\n        <a href=\"http://wemacentre.org/\" target=\"_blank\"></a>\n      </div>\n\n      <div id=\"pg8-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg8-pop2.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg8-pop-2')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      <div id=\"pg8-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/pg8-pop3.jpg\">\n        <div class=\"abs pointer\" onclick=\"hideOverlay('pg8-pop-3')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg8sec4Anim = new TimelineMax();\n        pg8sec4Anim.staggerFromTo(cOf(\"8-4-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .staggerFromTo(cOf(\"8-4-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, 0.6, \"-=0.4\")\n        .staggerFromTo(cOf(\"8-4-btn\"), 0.8, {opacity:0}, {opacity:1}, 0.6, \"-=0.4\")\n        .fromTo(cOf(\"8-4-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          addContentLinks();\n          cOf(\"8-4-btn\")[0].className += \" pointer pulse animatedpulse\";\n          cOf(\"8-4-btn\")[1].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg8sec4Anim.stop();\n        removeContentLinks();\n        hideOverlay('pg8-pop-2');\n        hideOverlay('pg8-pop-3');\n        cOf(\"8-4-btn\")[0].className = \"halfScaleC 8-4-btn\";\n        cOf(\"8-4-btn\")[1].className = \"halfScaleC 8-4-btn\";\n      }\n      ",
    "searchText": "08/14  SUSTAINABLE DEVELOPMENT  KENYA Click to read Combating child marriage in Mozambique  BACK  Click to read about advocating for girls' rights at the UN  “Thinking about my life in ten years, I imagine myself traveling and working in other countries of the world and encouraging and guiding other unfortunate children away from their struggles” – Mary, 17 Mary was forced to beg with her mother in the slums of Mombasa, Kenya. An employee from the Wema Centre, a local organisation sponsored by Terre des Hommes (Denmark), saw Mary begging in the street  and took her to the centre. The Wema Centre gave Mary the opportunity to learn and receive an education, empowering her to swap her life on the streets for a life in school.  ©TDH  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 9-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 9-1-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n      \n      <img class=\"halfScale 9-1-title\" src=\"/making-children-heard/static/_content/9-title.png\" style=\"top: 432px; left:629px;\"/>\n      <img class=\"halfScale 9-1-title\" src=\"/making-children-heard/static/_content/9-sub.png\" style=\"top: 520px; left: 428px;\"/>\n      <img class=\"halfScale 9-1-title\" src=\"/making-children-heard/static/_content/9-destination.png\" style=\"top: 644px; left: 644px;\"/>\n\n      <img class=\"halfScale 9-1-img\" src=\"/making-children-heard/static/_content/9-img-1.jpg\" style=\"top: 101px; left: 427px;\"/>\n      <img class=\"halfScale 9-1-img\" src=\"/making-children-heard/static/_content/9-img-2.jpg\" style=\"top: 699px; left: 149px;\"/>\n      <img id=\"9-read\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/read-more.png\" onclick=\"Publish.nextSection()\" style=\"top: 860px; left:747px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:706px;left:661px;width:120px;height:21px\">\n        <a href=\"https://destination-unknown.org/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:737px;left:362px;width:100px;height:21px\">\n        <a href=\"https://destination-unknown.org/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg9Anim = new TimelineMax();\n        pg9Anim.staggerFromTo(cOf(\"9-1-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .staggerFromTo(cOf(\"9-1-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, 0.6, \"-=1.0\")\n        .fromTo(idOf(\"9-read\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"9-1-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          addContentLinks();\n          pg9Bounce = new TimelineMax({repeat: -1, repeatDelay: 5});\n          pg9Bounce.to(idOf(\"9-read\"), 0.8, {y:-20, delay:0.8})\n          .to(idOf(\"9-read\"), 1, {y:0, ease:Bounce.easeOut}, \"-=0\")\n        }}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg9Anim.stop();\n        pg9Bounce.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "09/14  TERRE DES HOMMES  CAMPAIGNS  ©TDH / Andrea Frazzetta  CAMPAIGNING BACK  NEXT  Campaigning is built into the DNA of Terre des Hommes. We spearhead two campaigns which champion children’s rights – on children on the move and children influenced by mega sporting events  DESTINATION UNKNOWN Throughout 2017, the Destination Unknown campaign was active at global, regional and national levels, advocating for the human rights of children and  young people on the move to be upheld and respected. At the global level, Destination Unknown has been actively campaigning for two  READ MORE  ©TDH"
  }, {
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9-2.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 9-2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 9-2-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScaleC 9-2-btn\" onclick=\"showOverlay('9-gal')\" src=\"/making-children-heard/static/_content/btn-gal.jpg\" style=\"top: 742px; left: 125px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:552px;left:581px;width:200px;height:21px\">\n        <a href=\"http://www.childrenonthemove.org\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:583px;left:363px;width:345px;height:24px\">\n        <a href=\"http://www.childrenonthemove.org\" target=\"_blank\"></a>\n      </div>\n\n      <div id=\"9-gal\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img id=\"\" class=\"\" style=\"top:0px;left:0px\" src=\"/making-children-heard/static/_content/gal-bg.png\">\n        <img class=\"halfScale 9-gal-img-1\" style=\"left:352px; top:133px;\" src=\"/making-children-heard/static/_content/gal-1.png\">\n        <img class=\"halfScale 9-gal-img-2\" style=\"left:352px; top:135px;opacity:0\" src=\"/making-children-heard/static/_content/gal-2.png\">\n        <img class=\"halfScale 9-gal-img-3\" style=\"left:353px; top:137px;opacity:0\" src=\"/making-children-heard/static/_content/gal-3.png\">\n        <img class=\"halfScale 9-gal-img-4\" style=\"left:353px; top:139px;opacity:0\" src=\"/making-children-heard/static/_content/gal-4.png\">\n        <img class=\"halfScale 9-gal-img-5\" style=\"left:353px; top:139px;opacity:0\" src=\"/making-children-heard/static/_content/gal-5.png\">\n        <img class=\"halfScale 9-gal-img-6\" style=\"left:353px; top:139px;opacity:0\" src=\"/making-children-heard/static/_content/gal-6.png\">\n        <img class=\"halfScale 9-gal-img-7\" style=\"left:353px; top:137px;opacity:0\" src=\"/making-children-heard/static/_content/gal-7.png\">\n        <img class=\"halfScale 9-gal-img-8\" style=\"left:353px; top:137px;opacity:0\" src=\"/making-children-heard/static/_content/gal-8.png\">\n\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(1);\" style=\"top:811px;left:352px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(2);\" style=\"top:811px;left:435px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(3);\" style=\"top:811px;left:517px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(4);\" style=\"top:811px;left:600px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(5);\" style=\"top:811px;left:683px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(6);\" style=\"top:811px;left:766px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(7);\" style=\"top:811px;left:847px;width:84px;height:84px;\"></div>\n        <div class=\"abs pointer 9-gal-thumb\" onclick=\"galleryImg(8);\" style=\"top:811px;left:930px;width:84px;height:84px;\"></div>\n\n        <div class=\"abs pointer\" onclick=\"hideOverlay('9-gal')\" style=\"top:88px;left:1242px;width:38px;height:38px;\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg9sec2Anim = new TimelineMax();\n        pg9sec2Anim.fromTo(cOf(\"9-2-btn\"), 0.8, {opacity:0}, {opacity:1}, 0.8)\n        .fromTo(cOf(\"9-2-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: function(){\n          addContentLinks();\n          cOf(\"9-2-btn\")[0].className += \" pointer pulse animatedpulse\";\n        }}, \"-=0.4\")\n      }\n      \n      function galleryImg(index) {\n        for (var i=1; i <= 9; i++) {\n          if(i == index) {\n            TweenMax.to(cOf(\"9-gal-img-\"+i), 0.5, {opacity:1})\n          } else {\n            TweenMax.to(cOf(\"9-gal-img-\"+i), 0.5, {opacity:0});\n          }\n        }\n      }\n\n      function onPageLeave() {\n        pg9sec2Anim.stop();\n        removeContentLinks();\n        hideOverlay('9-gal')\n        cOf(\"9-2-btn\")[0].className = \"halfScaleC 9-2-btn\";\n      }\n      ",
    "searchText": "09/14  TERRE DES HOMMES  CAMPAIGNS  BACK  Click to view children's pictures of the hazards they face in South Africa  new international agreements, known as the UN Global Compacts on refugees and migration, to ensure they are childfocused and grounded on the rights of children. This is done with the aim of establishing a continuum of care, protection and support for all children on the move. Working with the Initiative for Child Rights in the Global Compacts – cochaired by Terre des Hommes and Save the Children – Destination Unknown led and participated in consultations and review meetings feeding into the Global Compacts, bringing our experience of working with children to the discussions. This collective work placed children’s rights on the agenda when governments began to negotiate the content of both Compacts.  Regional-level campaigning included Destination Unknown campaign partners in Southern Africa advocating for the rights of children on the move to be included in questions asked by the African Union committee responsible for rights and welfare. In seven global regions, Destination Unknown campaign members were active in advocacy, awareness-raising and mobilisation to strengthen protection of children in the move. For example, children and young people on the move in South Africa photographed the daily challenges they faced in Johannesburg. They then displayed their photographs in an exhibition within their local community – raising awareness on pollution, drug abuse, child abuse and other ©TDH social ills they are forced to live with.  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 10-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 10-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n\n      <img class=\"halfScale 10-title\" src=\"/making-children-heard/static/_content/10-title.png\" style=\"top: 258px; left:623px;\"/>\n      <img class=\"halfScale 10-title\" src=\"/making-children-heard/static/_content/10-sub.png\" style=\"top: 338px; left: 553px;\"/>\n\n      <img class=\"halfScale 10-img\" src=\"/making-children-heard/static/_content/10-img.jpg\" style=\"top: 762px; left: 806px;\"/>\n\n      <div class=\"addContentLink\" style=\"top:397px;left:405px;width:131px;height:24px\">\n        <a href=\"http://www.childrenwin.org/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg10Anim = new TimelineMax();\n        pg10Anim.staggerFromTo(cOf(\"10-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8, 0.8)\n        .fromTo(cOf(\"10-img\"), 0.8, {opacity:0, y:30}, {opacity:1, y:0}, \"-=0.4\")\n        .fromTo(cOf(\"10-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: addContentLinks}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg10Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "10/14  TERRE DES HOMMES  CAMPAIGNS  CHILDREN WIN Making mega sporting events respect child rights  BACK  The Children Win campaign, which is led by Terre des Hommes, aims to guarantee the rights of children are respected and promoted before, during and after mega sporting events. In 2017, the publication by UEFA of the bidding documents for the EURO 2024 football championship proved to be a watershed moment, as stipulations on human and child rights were included from the outset for the first time in a mega sporting event. Children Win also revisited Rio de Janeiro one year after the finale of the 2016 Olympic Games. The campaign interviewed children and parents from the favelas affected by construction work preparing for the Games.  Those interviewed highlighted how the ‘legacy’ of the games had not materialised for local residents, with facilities not being used and beneficial programmes curtailed. The Children Win campaign also influenced the human rights policy adopted by FIFA in 2017. Children Win fed into the final versions of these policies as part of the Sport and Rights Alliance, with a Terre des Hommes expert also sitting on FIFA’s human rights advisory board.  NEXT"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 11-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n        <img class=\"halfScale 11-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n        <img id=\"11-but-1\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/11-but-1.jpg\" style=\"top: 349px; left:169px;\" onclick=\"showOverlay2('11-pop-1'); hideOverlay2('11-pop-2'); hideOverlay2('11-pop-3'); showButton('11-but-1'); hideButton('11-but-2'); hideButton('11-but-3');animatePop1();\" />\n        <img id=\"11-but-2\" class=\"halfScale pointer hidden\" src=\"/making-children-heard/static/_content/11-but-2.jpg\" style=\"top: 521px; left:166px;\" onclick=\"showOverlay2('11-pop-2'); hideOverlay2('11-pop-1'); hideOverlay2('11-pop-3'); showButton('11-but-2'); hideButton('11-but-1'); hideButton('11-but-3');animatePop2();\" />\n        <img id=\"11-but-3\" class=\"halfScale pointer hidden\" src=\"/making-children-heard/static/_content/11-but-3.jpg\" style=\"top: 761px; left:163px;\" onclick=\"showOverlay2('11-pop-3'); hideOverlay2('11-pop-1'); hideOverlay2('11-pop-2'); showButton('11-but-3'); hideButton('11-but-1'); hideButton('11-but-2');animatePop3();\" />\n\n        <div id=\"11-pop-1\" class=\"\">\n          <img id=\"11-title-1\" class=\"halfScale\" src=\"/making-children-heard/static/_content/11-title-1.png\" style=\"top: 197px; left:399px;\"/>\n          <img class=\"halfScale\" src=\"/making-children-heard/static/_content/11-pop-1.jpg\" style=\"top: 246px; left:365px;\"/>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:760px;top:248px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 816, \"append\": \"\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:1055px;top:361px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 4009, \"append\": \"\", \"comma\": true}' ></h1>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:1075px;top:594px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 372, \"append\": \"\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:647px;top:832px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 183161256, \"append\": \"\", \"preppend\": \"\u20AC\", \"comma\": true}' ></h1>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:408px;top:833px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 5928, \"append\": \"\", \"comma\": true}' ></h1>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:357px;top:596px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 10125477, \"append\": \"\", \"comma\": true}' ></h1>\n          <h1 class=\"abs dinpro 11-no-1 11-numbers\" style=\"left:375px;top:358px; font-size: 3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 6562042, \"append\": \"\", \"comma\": true}' ></h1>\n        </div>\n\n        <div id=\"11-pop-2\" class=\"hidden noclick\">\n        <img id=\"11-title-2\" class=\"halfScale\" src=\"/making-children-heard/static/_content/11-title-2.png\" style=\"top: 197px; left:399px;\"/>\n          <img class=\"halfScale\" src=\"/making-children-heard/static/_content/11-pop-2.jpg\" style=\"top: 260px; left:365px;\"/>\n          <h1 class=\"abs dinpro 11-no-2 11-numbers\" style=\"left:679px;top:294px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 34, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-2 11-numbers\" style=\"left:820px;top:813px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 26, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-2 11-numbers\" style=\"left:1098px;top:633px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 12, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-2 11-numbers\" style=\"left:400px;top:420px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 12, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-2 11-numbers\" style=\"left:1104px;top:493px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 16, \"append\": \"%\"}' ></h1>\n        </div>\n        <div id=\"11-pop-3\" class=\"hidden noclick\">\n        <img id=\"11-title-3\" class=\"halfScale\" src=\"/making-children-heard/static/_content/11-title-3.png\" style=\"top: 197px; left:399px;\"/>\n          <img class=\"halfScale\" src=\"/making-children-heard/static/_content/11-pop-3.jpg\" style=\"top: 266px; left:405px;\"/>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:440px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 39, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:663px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 28, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:878px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 16, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:1111px;top:441px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 8, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:452px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 3, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:672px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 2, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:891px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 1, \"append\": \"%\"}' ></h1>\n          <h1 class=\"abs dinpro 11-no-3 11-numbers\" style=\"left:1110px;top:777px; font-size: 3.1em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 3, \"append\": \"%\"}' ></h1>\n        </div>\n\n      ",
    "script": "\n      function onPageEnter() {\n        pg11Anim = new TimelineMax();\n        pg11pop1Anim = new TimelineMax();\n        pg11pop2Anim = new TimelineMax();\n        pg11pop3Anim = new TimelineMax();\n        pg11Anim.fromTo(cOf(\"11-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: animatePop1()}, 1)\n      }\n      \n      function animatePop1() {\n        pg11pop1Anim.fromTo(idOf(\"11-title-1\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.5)\n        .fromTo(cOf(\"11-no-1\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[0]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-1\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-1\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[2]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-1\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[3]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-1\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[4]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-1\")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[5]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-1\")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-1\")[6]);}},\"-=0.2\")\n      }\n\n      function animatePop2() {\n        pg11pop2Anim.fromTo(idOf(\"11-title-2\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.5)\n        .fromTo(cOf(\"11-no-2\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-2\")[0]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-2\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-2\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-2\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-2\")[2]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-2\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-2\")[3]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-2\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-2\")[4]);}},\"-=0.2\")\n      }\n\n      function animatePop3() {\n        pg11pop3Anim.fromTo(idOf(\"11-title-3\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.5)\n        .fromTo(cOf(\"11-no-3\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[0]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[2]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[3]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[4]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[5]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[6]);}},\"-=0.2\")\n        .fromTo(cOf(\"11-no-3\")[7], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"11-no-3\")[7]);}},\"-=0.2\")\n      }\n\n      function onPageLeave() {\n        resetNumbers('11-numbers');\n        pg11Anim.stop();\n        pg11pop1Anim.stop();\n        pg11pop2Anim.stop();\n        pg11pop3Anim.stop();\n        showOverlay2('11-pop-1');\n        showButton('11-but-1');\n        hideOverlay2('11-pop-2');\n        hideOverlay2('11-pop-3');\n        hideButton('11-but-2');\n        hideButton('11-but-3');\n      }\n      ",
    "searchText": "11/14 Statistics TERRE DES HOMMES TERRE DES HOMMES AT A GLANCE 816 Number of projects in 67 countries. 4,009 Number of employees in the field. 372 Number of employees at member organisation HQs. €183,161,256 Global income in EUR. 5,928 Number of volunteers. 10,125,477 Number of indirect beneficiaries. 6,562,042 Number of direct beneficiaries. PROJECT EXPENDITURE PER REGION 34% Middle East. 26% Africa. 16% Asia. 12% Latin America. 12% Europe. PROJECTS PER SECTOR OF ACTIVITY 39% Child Protection. 28% Humanitarian Aid. 16% Health and Nutrition. 8% Education and Professional Training. 3% Youth Empowerment. 2% Girls' and Women's Rights. 1% Community Based Development. 3% Other."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 12-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 12-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n      <img id=\"12-title-1\" class=\"halfScale\" src=\"/making-children-heard/static/_content/12-title-1.png\" style=\"top: 195px; left:417px;\"/>\n      <img id=\"12-but-1\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/12-but-1.jpg\" style=\"top: 346px; left:157px;\" onclick=\"showOverlay2('12-pop-1'); hideOverlay2('12-pop-2'); showButton('12-but-1'); hideButton('12-but-2'); p12AnimatePop1();\" />\n      <img id=\"12-but-2\" class=\"halfScale pointer hidden\" src=\"/making-children-heard/static/_content/12-but-2.jpg\" style=\"top: 560px; left:175px;\" onclick=\"showOverlay2('12-pop-2'); hideOverlay2('12-pop-1'); showButton('12-but-2'); hideButton('12-but-1'); p12AnimatePop2();\" />\n\n      <div id=\"12-pop-1\" class=\"\">\n        <img class=\"halfScale\" src=\"/making-children-heard/static/_content/12-pop-1.jpg\" style=\"top: 261px; left:397px;\"/>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:483px;top:706px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 37, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:483px;top:742px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 34, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:483px;top:779px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 12, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:483px;top:815px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 9, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:483px;top:852px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 6, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:483px;top:889px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 2, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:928px;top:706px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 82, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:928px;top:741px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 14, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 12-no-1 12-numbers\" style=\"left:928px;top:808px; font-size: 1.4em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 4, \"append\": \"%\"}' ></h1>\n      </div>\n\n      <div id=\"12-pop-2\" class=\"hidden noclick\">\n        <img class=\"halfScale\" src=\"/making-children-heard/static/_content/12-pop-2.jpg\" style=\"top: 264px; left:414px;\"/>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:494px;width:28px;height:244px;background-color:#699390\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:529px;width:28px;height:315px;background-color:#a5d8ce\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:615px;width:28px;height:260px;background-color:#699390\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:649px;width:28px;height:344px;background-color:#a5d8ce\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:737px;width:28px;height:271px;background-color:#699390\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:770px;width:28px;height:363px;background-color:#a5d8ce\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:856px;width:28px;height:315px;background-color:#699390\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:890px;width:28px;height:344px;background-color:#a5d8ce\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:977px;width:28px;height:323px;background-color:#699390\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:1009px;width:28px;height:357px;background-color:#a5d8ce\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:1097px;width:28px;height:369px;background-color:#699390\"></div>\n        <div class=\"abs originBC noOverflow 12-graph\" style=\"bottom:206px;left:1131px;width:28px;height:416px;background-color:#a5d8ce\"></div>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg12Anim = new TimelineMax();\n        pg12pop1Anim = new TimelineMax();\n        pg12pop2Anim = new TimelineMax();\n        pg12Anim.fromTo(idOf(\"12-title-1\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 1)\n        .fromTo(cOf(\"12-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: p12AnimatePop1()}, \"-=0.4\")\n      }\n      \n      function p12AnimatePop1() {\n        pg12pop1Anim.fromTo(cOf(\"12-no-1\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[0]);}}, 0.5)\n        .fromTo(cOf(\"12-no-1\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[2]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[3]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[4]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[5]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[6], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[6]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[7], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[7]);}},\"-=0.2\")\n        .fromTo(cOf(\"12-no-1\")[8], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"12-no-1\")[8]);}},\"-=0.2\")\n      }\n\n      function p12AnimatePop2() {\n        pg12pop2Anim.fromTo(cOf(\"12-graph\")[0], 0.6, {height:0}, {height:244}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[1], 0.6, {height:0}, {height:315}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[2], 0.6, {height:0}, {height:260}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[3], 0.6, {height:0}, {height:344}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[4], 0.6, {height:0}, {height:271}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[5], 0.6, {height:0}, {height:363}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[6], 0.6, {height:0}, {height:315}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[7], 0.6, {height:0}, {height:344}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[8], 0.6, {height:0}, {height:323}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[9], 0.6, {height:0}, {height:357}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[10], 0.6, {height:0}, {height:369}, \"-=0.4\")\n        .fromTo(cOf(\"12-graph\")[11], 0.6, {height:0}, {height:416}, \"-=0.4\")\n\n      }\n\n      function onPageLeave() {\n        resetNumbers('12-numbers');\n        pg12Anim.stop();\n        pg12pop1Anim.stop();\n        pg12pop2Anim.stop();\n        showOverlay2('12-pop-1');\n        showButton('12-but-1');\n        hideOverlay2('12-pop-2');\n        hideButton('12-but-2');\n      }\n      ",
    "searchText": "12/14 Finances TERRE DES HOMMES TERRE DES HOMMES IN FIGURES Income by source/expenditure by sector. 37% General Public. 34% Government funds. 12% UN funds. 9% European Union funds. 6% Corporate sector. 2% Other. 82% Field projects. 14% Administration, fund raising and communication. 4% Advocacy and information. Global income 2012-2017"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "  \n      <img class=\"halfScale 13-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n      <img class=\"halfScale 13-arrow pointer\" src=\"/making-children-heard/static/_content/btn-forward.png\" onclick=\"Publish.nextPage()\" style=\"top: 497px; left: 1259px;\"/>\n      <img id=\"13-title-1\" class=\"halfScale\" src=\"/making-children-heard/static/_content/13-title.png\" style=\"top: 145px; left:368px;\"/>\n      <img id=\"13-but-1\" class=\"halfScale pointer\" src=\"/making-children-heard/static/_content/13-but-1.jpg\" style=\"top: 278px; left:364px;\" onclick=\"showOverlay2('13-pop-1'); hideOverlay2('13-pop-2'); hideOverlay2('13-pop-3'); hideOverlay2('13-pop-4'); showButton('13-but-1'); hideButton('13-but-2'); hideButton('13-but-3'); hideButton('13-but-4'); p13AnimatePop1();\" />\n      <img id=\"13-but-2\" class=\"halfScale pointer hidden\" src=\"/making-children-heard/static/_content/13-but-2.jpg\" style=\"top: 434px; left:365px;\" onclick=\"showOverlay2('13-pop-2'); hideOverlay2('13-pop-1'); hideOverlay2('13-pop-3'); hideOverlay2('13-pop-4'); showButton('13-but-2'); hideButton('13-but-1'); hideButton('13-but-3'); hideButton('13-but-4'); p13AnimatePop2();\" />\n      <img id=\"13-but-3\" class=\"halfScale pointer hidden\" src=\"/making-children-heard/static/_content/13-but-3.jpg\" style=\"top: 617px; left:365px;\" onclick=\"showOverlay2('13-pop-3'); hideOverlay2('13-pop-2'); hideOverlay2('13-pop-1'); hideOverlay2('13-pop-4'); showButton('13-but-3'); hideButton('13-but-2'); hideButton('13-but-1'); hideButton('13-but-4'); p13AnimatePop3();\" />\n      <img id=\"13-but-4\" class=\"halfScale pointer hidden\" src=\"/making-children-heard/static/_content/13-but-4.jpg\" style=\"top: 780px; left:365px;\" onclick=\"showOverlay2('13-pop-4'); hideOverlay2('13-pop-2'); hideOverlay2('13-pop-3'); hideOverlay2('13-pop-1'); showButton('13-but-4'); hideButton('13-but-2'); hideButton('13-but-3'); hideButton('13-but-1'); p13AnimatePop4();\" />\n\n      <div id=\"13-pop-1\" class=\"\">\n        <img class=\"halfScale\" src=\"/making-children-heard/static/_content/13-pop-1.jpg\" style=\"top: 272px; left:587px;\"/>\n        <h1 class=\"abs dinpro 13-no-1 13-numbers\" style=\"left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 75.5, \"append\": \"%\", \"decimals\": 1}' ></h1>\n        <h1 class=\"abs dinpro 13-no-1 13-numbers\" style=\"left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 10.5, \"append\": \"%\", \"decimals\": 1}' ></h1>\n        <h1 class=\"abs dinpro 13-no-1 13-numbers\" style=\"left:617px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 8.5, \"append\": \"%\", \"decimals\": 1}' ></h1>\n        <h1 class=\"abs dinpro 13-no-1 13-numbers\" style=\"left:910px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 5.1, \"append\": \"%\", \"decimals\": 1}' ></h1>\n        <h1 class=\"abs dinpro 13-no-1 13-numbers\" style=\"left:910px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 0.4, \"append\": \"%\", \"decimals\": 1}' ></h1>\n      </div>\n\n      <div id=\"13-pop-2\" class=\"hidden noclick\">\n        <img class=\"halfScale\" src=\"/making-children-heard/static/_content/13-pop-2.jpg\" style=\"top: 272px; left:587px;\"/>\n        <h1 class=\"abs dinpro 13-no-2 13-numbers\" style=\"left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 60, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-2 13-numbers\" style=\"left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 27, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-2 13-numbers\" style=\"left:617px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 13, \"append\": \"%\"}' ></h1>\n      </div>\n\n      <div id=\"13-pop-3\" class=\"hidden noclick\">\n        <img class=\"halfScale\" src=\"/making-children-heard/static/_content/13-pop-3.jpg\" style=\"top: 272px; left:587px;\"/>\n        <h1 class=\"abs dinpro 13-no-3 13-numbers\" style=\"left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 48, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-3 13-numbers\" style=\"left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 27, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-3 13-numbers\" style=\"left:617px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 9, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-3 13-numbers\" style=\"left:881px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 8, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-3 13-numbers\" style=\"left:881px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 7, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-3 13-numbers\" style=\"left:881px;top:891px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 1, \"append\": \"%\"}' ></h1>\n      </div>\n\n      <div id=\"13-pop-4\" class=\"hidden noclick\">\n        <img class=\"halfScale\" src=\"/making-children-heard/static/_content/13-pop-4.jpg\" style=\"top: 272px; left:587px;\"/>\n        <h1 class=\"abs dinpro 13-no-4 13-numbers\" style=\"left:617px;top:818px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 58, \"append\": \"%\"}' ></h1>\n        <h1 class=\"abs dinpro 13-no-4 13-numbers\" style=\"left:617px;top:854px; font-size: 1.3em; font-weight:300; margin:0; color:#231f20;\"  data-number='{\"to\": 42, \"append\": \"%\"}' ></h1>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n        pg13pop1Anim = new TimelineMax();\n        pg13pop2Anim = new TimelineMax();\n        pg13pop3Anim = new TimelineMax();\n        pg13pop4Anim = new TimelineMax();\n        pg13Anim.fromTo(idOf(\"13-title-1\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 1)\n        .fromTo(cOf(\"13-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: p13AnimatePop1()}, \"-=0.4\")\n      }      \n\n      function p13AnimatePop1() {\n        pg13pop1Anim.fromTo(cOf(\"13-no-1\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-1\")[0]);}}, 0.5)\n        .fromTo(cOf(\"13-no-1\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-1\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-1\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-1\")[2]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-1\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-1\")[3]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-1\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-1\")[4]);}},\"-=0.2\")\n      }\n\n      function p13AnimatePop2() {\n        pg13pop2Anim.fromTo(cOf(\"13-no-2\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-2\")[0]);}}, 0.5)\n        .fromTo(cOf(\"13-no-2\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-2\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-2\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-2\")[2]);}},\"-=0.2\")\n      }\n\n      function p13AnimatePop3() {\n        pg13pop3Anim.fromTo(cOf(\"13-no-3\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-3\")[0]);}}, 0.5)\n        .fromTo(cOf(\"13-no-3\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-3\")[1]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-3\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-3\")[2]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-3\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-3\")[3]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-3\")[4], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-3\")[4]);}},\"-=0.2\")\n        .fromTo(cOf(\"13-no-3\")[5], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-3\")[5]);}},\"-=0.2\")\n      }\n\n      function p13AnimatePop4() {\n        pg13pop4Anim.fromTo(cOf(\"13-no-4\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-4\")[0]);}}, 0.5)\n        .fromTo(cOf(\"13-no-4\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"13-no-4\")[1]);}},\"-=0.2\")\n      }\n\n      function onPageLeave() {\n        resetNumbers('13-numbers');\n        pg13Anim.stop();\n        pg13pop1Anim.stop();\n        pg13pop2Anim.stop();\n        pg13pop3Anim.stop();\n        pg13pop4Anim.stop();\n        showOverlay2('13-pop-1');\n        showButton('13-but-1');\n        hideOverlay2('13-pop-2');\n        hideOverlay2('13-pop-3');\n        hideOverlay2('13-pop-4');\n        hideButton('13-but-2');\n        hideButton('13-but-3');\n        hideButton('13-but-4');\n      }\n      ",
    "searchText": "13/14 Secrtariat Finances TERRE DES HOMMES INTERNATIONAL SECRETARIAT FINANCE REPORT   ASSETS Percentage of total balance sheet (527,031.18 CHF). 75.5% Cash at Banks. 10.5% Accrued assets. 8.5% Accounts receivable. 5.1% Share development durable. 0.4% Cash. LIABILITIES AND OWN FUNDS Percentage of total balance sheet (527,031.18 CHF). 60% Own funds. 27% Project funds. 13% accrued expenses. INCOME Percentage of total income (1,585,093.43 CHF) 48% Membership fee. 27% Children Win grant. 9% Oak grant. 8% Specific projects. 7% Other resources. 1% Bank interest and gain on exchange. EXPENDITURE percentage of total expenditure (1,629,221.02 CHF) 58% Core costs. 42% Special activities"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 14-arrow pointer\" src=\"/making-children-heard/static/_content/btn-back.png\" onclick=\"Publish.previousPage()\" style=\"top: 497px; left: 32px;\"/>\n\n      <img class=\"halfScale 14-title\" src=\"/making-children-heard/static/_content/14-title.png\" style=\"top: 194px; left:365px;\"/>\n      \n      <img class=\"halfScale 14-text\" src=\"/making-children-heard/static/_content/14-text-3.png\" style=\"top: 368px; left: 144px;\"/>\n      <img class=\"halfScale 14-text\" src=\"/making-children-heard/static/_content/14-text-2.png\" style=\"top: 517px; left: 144px;\"/>\n      <img class=\"halfScale 14-text\" src=\"/making-children-heard/static/_content/14-text-1.png\" style=\"top: 689px; left: 144px;\"/>\n      \n      <a href=\"http://www.terredeshommes.org/about/structure/\" target=\"_blank\">\n        <img class=\"halfScaleC 14-img\" src=\"/making-children-heard/static/_content/14-img-3.png\" style=\"top: 211px; left: 99px;\"/>\n      </a>\n      <a href=\"http://www.terredeshommes.org/members/\" target=\"_blank\">\n        <img class=\"halfScaleC 14-img\" src=\"/making-children-heard/static/_content/14-img-2.png\" style=\"top: 360px; left: 99px;\"/>\n      </a>\n      <a href=\"http://www.terredeshommes.org/contacts-2/\" target=\"_blank\">\n        <img class=\"halfScaleC 14-img\" src=\"/making-children-heard/static/_content/14-img-1.png\" style=\"top: 533px; left: 99px;\"/>\n      </a>\n\n      <div class=\"addContentLink\" style=\"top:490px;left:424px;width:158px;height:24px\">\n        <a href=\"http://www.oakfnd.org/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:306px;left:934px;width:289px;height:24px\">\n        <a href=\"http://www.epim.info/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:338px;left:806px;width:262px;height:24px\">\n        <a href=\"http://www.epim.info/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        pg14Anim = new TimelineMax();\n        pg14Anim.fromTo(cOf(\"14-title\"), 0.8, {opacity:0, y:-30}, {opacity:1, y:0}, 0.8)\n        .staggerFromTo(cOf(\"14-img\"), 0.8, {scale:0}, {scale:0.5, ease:Back.easeOut.config(1.7)}, 0.6, \"-=0.4\")\n        .staggerFromTo(cOf(\"14-text\"), 0.8, {opacity:0, x:-30}, {opacity:1, x:0}, 0.6, \"-=1.8\")\n        .fromTo(cOf(\"14-arrow\"), 0.8, {opacity:0}, {opacity:1, onComplete: addContentLinks}, \"-=0.4\")\n      }\n      \n\n      function onPageLeave() {\n        pg14Anim.stop();\n        removeContentLinks();\n      }\n      ",
    "searchText": "14/14  TERRE DES HOMMES  ACKNOWLEDGEMENTS  CLICK ICONS TO LINK THROUGH TO  International secretariat staff  BACK  Member organisations  International board  ACKNOWLEDGEMENTS Terre des Hommes wishes to express its profound gratitude to all donors and supporters for their ongoing and demonstrable commitment to raising standards for children, and making the changes necessary for a better world. Terre des Hommes is extremely grateful to the Oak Foundation for its long-standing partnership supporting the protection of children on the move and children affected by mega sporting events.  Terre des Hommes would also like to thank the European Programme for Integration and Migration, for its support and assistance in championing the rights of children on the move at European level. The names of all children mentioned in this report have been changed to protect their identity.  Managing Editor Delphine Moralis  Contributors Lysiane André, Laura Chello, Caroline Horne, Marc Joly, Eylah Kadjar-Hamouda  Production Elisa Buccolini, Paul Creeney Design Touchline  Special Thanks Jessica Fiorelli, Vanessa Nkembi"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var thisPage = document.querySelector('.currentPage') \n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var thisPage = document.querySelector('.currentPage') \n        var contentLinks = [].slice.call(thisPage.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n      \n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function showOverlay2(idx) {\n        idOf(idx).className = 'visible'\n      }\n\n      function hideOverlay2(idx) {\n        idOf(idx).className = 'hidden noclick'\n      }\n\n      function showButton(idx) {\n        idOf(idx).className = 'halfScale pointer'\n      }\n\n      function hideButton(idx) {\n        idOf(idx).className = 'halfScale pointer hidden'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend + comp+dp+append;\n            }else{\n              element.innerHTML = preppend + obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js




/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        router.push(context.getters.routeFromIndex(payload, 1), function () {
          // console.log(payload)
          context.commit('CHANGE_SECTION_INDEX', {
            pageIndex: payload,
            sectionIndex: 0
          });
        });
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
          // console.log(payload)
          context.commit('CHANGE_SECTION_INDEX', {
            pageIndex: payload.pageIndex - 1,
            sectionIndex: payload.sectionIndex - 1
          });
        });
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      context.commit('UPDATE_PAGE_SCALE', { pageScale: 1 });
    } else {
      var newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == 'Contents';
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == 'Languages';
  },
  showSearch: function showSearch(state) {
    return state.activePanel == 'Search';
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + '/static/_content/' + state.document.companyLogo;
    } else return getters.basePath + '/static/kp-logo-white.svg';
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return '/' + pageIndex + '-' + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          currentPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          leftPage: null,
          currentPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][0];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][0];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][0];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][0];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][0];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][0];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) return getters.routeFromIndex(Math.ceil(getters.pageIndex - 2), 1);
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null) return null;
    if (state.isDoublePage && getters.doublePage) return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: 'scale(' + getters.pageContainerZoomLevel * state.pageScale + ')'
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + 'px ' + state.zoomOriginY + 'px';
    } else {
      styleObject.transformOrigin = '0px 0px';
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + '-' + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join('\n');
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return '/' + (pageLink.index + 1) + '-' + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch)) return;
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: 1
    };
  },
  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage 


  //#endregion

});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  if (state.zoomLevel < 1) state.zoomLevel = 1;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: true,
    galleryImages: []
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
    };document.addEventListener("mousedown", this.mouseDownHandler);
    document.addEventListener("mousemove", this.mouseMoveHandler);
    document.addEventListener("mouseup", this.mouseUpHandler);
    document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;

    var hammertime = new hammer_default.a(document.getElementById("app"), {
      touchAction: "auto"
    });
    hammertime.get('swipe').set({ direction: hammer_default.a.DIRECTION_ALL });
    hammertime.get("pinch").set({ enable: true });
    hammertime.add(new hammer_default.a.Tap({ event: "doubletap", taps: 2 }));
    hammertime.add(new hammer_default.a.Tap({ event: "singletap" }));
    hammertime.get("doubletap").recognizeWith("singletap");
    hammertime.get("singletap").requireFailure("doubletap");

    hammertime.on("singletap", function (e) {
      if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1) && Publish.zoomEnabled) {
        mouse.lastX = e.srcEvent.clientX;
        mouse.lastY = e.srcEvent.clientY;
      }
    });

    hammertime.on("doubletap", function (e) {
      if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1)) && Publish.zoomEnabled) {
        Publish.toggleZoom({
          zoomOriginX: e.srcEvent.clientX,
          zoomOriginY: e.srcEvent.clientY
        });
      }
    });

    hammertime.on("pinchin", function (e) {
      Publish.pinchZoom({
        zoomOriginX: e.center.x,
        zoomOriginY: e.center.y,
        zoomLevel: e.scale
      });
    });

    hammertime.on("pinchout", function (e) {
      Publish.pinchZoom({
        zoomOriginX: e.center.x,
        zoomOriginY: e.center.y,
        zoomLevel: e.scale
      });
    });

    hammertime.on("pan", function (e) {
      mouse.x = e.srcEvent.clientX;
      mouse.y = e.srcEvent.clientY;
      mouse.deltaX = mouse.x - mouse.lastX;
      mouse.deltaY = mouse.y - mouse.lastY;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    });

    hammertime.on("panstart", function (e) {
      if (Publish.isZoomed) {
        mouseDown = true;
        mouse.lastX = e.srcEvent.clientX;
        mouse.lastY = e.srcEvent.clientY;
      }
    });

    hammertime.on("panend", function (e) {
      if (mouseDown && Publish.pagesVisible) {
        mouse.lastX = mouse.x;
        mouse.lastX = mouse.y;
        mouseDown = false;
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isGalleryOpen) {
        if (e.direction === hammer_default.a.DIRECTION_LEFT) {
          if (!Publish.rightToLeft) {
            Publish.nextGallerySlide();
          } else {
            Publish.previousGallerySlide();
          }
        } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
          if (!Publish.rightToLeft) {
            Publish.previousGallerySlide();
          } else {
            Publish.nextGallerySlide();
          }
        }
      } else if (Publish.videoURL == "" && !Publish.isZoomed) {
        if (Publish.isMobile) {
          if (Publish.mobileSwitch) {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextMobilePage();
              } else {
                Publish.goToPreviousMobilePage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousMobilePage();
              } else {
                Publish.goToNextMobilePage();
              }
            }
          } else {
            if (!Publish.isZoomed) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextPage();
                } else {
                  Publish.goToPreviousPage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousPage();
                } else {
                  Publish.goToNextPage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            }
          }
        } else {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              if (Publish.currentPage.sectionIndex == 0 || Publish.currentPage.sectionIndex == Publish.currentPages.length - 1) {
                Publish.goToNextPage();
              } else {}
            } else {
              Publish.goToPreviousPage();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              if (Publish.currentPage.sectionIndex == 0 || Publish.currentPage.sectionIndex == Publish.currentPages.length - 1) {
                Publish.goToPreviousPage();
              } else {}
            } else {
              Publish.goToNextPage();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_UP) {
            if (Publish.pagesVisible) Publish.goToNextSection();
          } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
            if (Publish.pagesVisible) Publish.goToPreviousSection();
          }
        }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if ((e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1)) && Publish.zoomEnabled) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          if (Publish.currentPage.sectionIndex == 0 || Publish.currentPage.sectionIndex == Publish.currentPages.length - 1) {
            Publish.goToPreviousPage();
          } else {}
        } else {
          Publish.goToNextPage();
        }
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          if (Publish.currentPage.sectionIndex == 0 || Publish.currentPage.sectionIndex == Publish.currentPages.length - 1) {
            Publish.goToNextPage();
          } else {}
        } else {
          Publish.goToPreviousPage();
        }
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js

/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute('data-useragent', navigator.userAgent);
    documentElement.setAttribute('data-platform', navigator.platform);
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler() {
    Publish.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-111093701-15',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPage', 'pagesVisible', 'isZoomed', 'showContents', 'zoomLevel', 'rightToLeft', 'zoomEnabled', 'isMobile', 'mobileSwitch', 'currentMobilePageIndex', 'videoURL', 'isGalleryOpen', 'doublePage', 'currentPages'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: 'TOGGLE_ZOOM'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'goToPreviousMobilePage', 'goToNextMobilePage', 'nextPage', 'previousPage', 'nextSection', 'previousSection', 'previousMobilePage', 'nextMobilePage', 'updateZoom', 'startZoom', 'changeWindowSize', 'checkMobileLanding', 'updateVideoURL', 'pinchZoom', 'panZoom', 'openVideo', 'isPhantom', 'openGallery', 'closeGallery', 'goToGallerySlide', 'nextGallerySlide', 'previousGallerySlide'])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    this.changeWindowSize({
      width: window.innerWidth,
      height: window.innerHeight
    });
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nl3u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Nwp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pb/U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V56Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yHNM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.9dcde06da220e988b46e.js